import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full bg-white py-16 px-4 pb-32" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        {/* Cost of Inaction */}
        <div className="mb-16 bg-red-50 border border-red-100 p-8 rounded-2xl text-center" data-id="element-59">
          <h3 className="text-xl font-bold text-red-800 mb-4 uppercase" data-id="element-60">
            ⏳ EL COSTO DE NO ACTUAR
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-61">
            Cada temporada sin acompañamiento:
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-62">
            {['aumenta la frustración', 'se pierde confianza progresivamente', 'se debilita la motivación', 'crece el riesgo de abandono'].map((item, i) => <span key={i} className="bg-white px-4 py-2 rounded shadow-sm text-red-700 font-medium" data-id="element-63">
                – {item}
              </span>)}
          </div>
          <p className="font-bold text-gray-900" data-id="element-64">
            El desarrollo mental no se entrena solo.
          </p>
        </div>

        {/* Comparison note */}
        <div className="mb-10 bg-amber-50 border border-amber-200 p-6 rounded-2xl text-center" data-id="element-65">
          <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-66">
            💡 Una sola sesión con psicólogo deportivo puede costar más que este
            programa completo.
          </p>
          <p className="text-gray-600" data-id="element-67">
            Aquí obtenés herramientas aplicables para acompañarlo durante toda
            su etapa competitiva.
          </p>
        </div>

        {/* Pricing Card */}
        <div id="precio" className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-green-500 relative scroll-mt-8" data-id="element-68">
          <div className="bg-green-600 text-white text-center py-4" data-id="element-69">
            <p className="font-bold text-lg uppercase tracking-wider" data-id="element-70">
              💰 Precio de Lanzamiento
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-71">
            <div className="mb-8" data-id="element-72">
              <p className="text-gray-500 text-lg line-through mb-2" data-id="element-73">
                Precio regular: ARS $59.990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-74">
                <span className="text-2xl font-bold text-red-600" data-id="element-75">🔥 HOY:</span>
                <span className="text-5xl md:text-6xl font-black text-gray-900" data-id="element-76">
                  ARS $19.990
                </span>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 text-left max-w-lg mx-auto mb-10" data-id="element-77">
              <ul className="space-y-3" data-id="element-78">
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-79">
                  <CheckIcon className="text-green-500" data-id="element-80" /> 5 tomos completos
                </li>
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-81">
                  <CheckIcon className="text-green-500" data-id="element-82" /> 3 bonos exclusivos
                </li>
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-83">
                  <CheckIcon className="text-green-500" data-id="element-84" /> Workbook imprimible
                </li>
              </ul>
              <ul className="space-y-3" data-id="element-85">
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-86">
                  <CheckIcon className="text-green-500" data-id="element-87" /> Acceso de por vida
                </li>
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-88">
                  <CheckIcon className="text-green-500" data-id="element-89" /> Descarga digital
                  inmediata
                </li>
                <li className="flex items-center gap-2 font-medium text-gray-700" data-id="element-90">
                  <CheckIcon className="text-green-500" data-id="element-91" /> Pago seguro
                </li>
              </ul>
            </div>

            <a href="https://checkout.impulsodigitalx.shop/cart/45727930024097:1" className="block w-full bg-green-600 hover:bg-green-700 text-white text-2xl md:text-3xl font-bold py-6 px-4 rounded-xl shadow-xl transform transition hover:scale-105 mb-6 animate-pulse" data-id="element-92">
              👉 QUIERO ACCEDER AHORA
            </a>

            <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mb-8" data-id="element-93">
              <Lock className="w-4 h-4" data-id="element-94" />
              <span data-id="element-95">Pago seguro con Mercado Pago.</span>
            </div>

            {/* Guarantee */}
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 flex flex-col md:flex-row items-center gap-4 text-left" data-id="element-96">
              <div className="bg-yellow-100 p-3 rounded-full flex-shrink-0" data-id="element-97">
                <ShieldCheck className="w-10 h-10 text-yellow-600" data-id="element-98" />
              </div>
              <div data-id="element-99">
                <h4 className="font-bold text-gray-900 text-lg" data-id="element-100">
                  🛡 GARANTÍA 7 DÍAS
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-101">
                  Probalo sin riesgo. Si no estás conforme, solicitás devolución
                  completa.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Final Decision */}
        <div className="mt-16 text-center" data-id="element-102">
          <h3 className="text-2xl font-black text-gray-900 mb-6 uppercase" data-id="element-103">
            ⚽ LO QUE LOS CLUBES NO ENSEÑAN A LOS PADRES
          </h3>
          <div className="max-w-2xl mx-auto space-y-3 mb-8" data-id="element-104">
            <p className="text-lg text-gray-700" data-id="element-105">El talento se entrena.</p>
            <p className="text-lg text-gray-700" data-id="element-106">La técnica se practica.</p>
            <p className="text-xl font-bold text-gray-900" data-id="element-107">
              Pero el acompañamiento emocional empieza en casa.
            </p>
          </div>
          <p className="text-lg text-gray-700 mb-8" data-id="element-108">
            Convertite en el apoyo que todo futbolista necesita.
          </p>

          <a href="https://checkout.impulsodigitalx.shop/cart/45727930024097:1" className="inline-flex flex-col items-center justify-center gap-1 bg-green-600 hover:bg-green-700 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-lg shadow-lg transform transition hover:scale-105 hover:shadow-xl" data-id="element-109">
            <span data-id="element-110">👉 ACCEDER AL PROGRAMA AHORA</span>
          </a>
        </div>
      </div>
    </section>;
}
function CheckIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={`w-5 h-5 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-111">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-112" />
    </svg>;
}